// Shared Tenant + Eviction constants and helpers.

export const TENANT_STATUSES = ["pending_move_in", "active", "former"] as const;

export const REMOVAL_REASONS = [
  "moved_out",
  "lease_ended",
  "eviction",
  "deceased",
  "other",
] as const;

const TENANT_STATUS_LABELS: Record<string, string> = {
  pending_move_in: "Pending move-in",
  active: "Active",
  former: "Past",
};

const REMOVAL_REASON_LABELS: Record<string, string> = {
  moved_out: "Moved out",
  lease_ended: "Lease ended",
  eviction: "Eviction",
  deceased: "Deceased",
  other: "Other",
};

export function tenantStatusLabel(s: string): string {
  return TENANT_STATUS_LABELS[s] ?? s;
}

export function removalReasonLabel(r: string | null): string {
  if (!r) return "—";
  return REMOVAL_REASON_LABELS[r] ?? r;
}

export function tenantStatusBadge(s: string): string {
  if (s === "active") return "ok";
  if (s === "pending_move_in") return "info";
  return "muted"; // former
}
